





$(function(){
    $(".product-customizer-option-description").each(function(i){
        if ($(this).text().indexOf("__LINK") != -1){
            var text = $(this).text();
            var desc = text.split("__LINK")[0];
            var index = text.indexOf("__LINK")+7; // Starting double underscore index
            var end_index = text.substr(index).indexOf("__"); // Ending double underscore index
            var link_cmd = text.substr(index,end_index);
            var link = link_cmd.split("~")[0];
            var link_text = link_cmd.split("~")[1];
            var link_color = link_cmd.split("~")[2];
            $(this).html(desc + "<a href='"+link+"' target='_blank' style='color: "+link_color+"; text-decoration: underline; font-weight: bold;'>"+link_text+"</a>");
        }
        $(this).css("display","block");
     });
});